import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuAnalytics = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M13.8 10.6L17 7.4L13.8 4.2M4.2 4.2L1 7.4L4.2 10.6M11 1L7 13.8",
	stroke: "#434343",
	strokeWidth: 1.2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgMainMenuAnalytics);
export default ForwardRef;
